module.exports = __webpack_public_path__ + "assets/img/onboarding_4.17111953.png";